angular.module('cvsApp').service('updateAccountInfoService', ['networkService', 'xdrService', 'configManager',
    'updateAccountInfoModel', 'cvsAppData', '$base64', function (NS, XS, CM, UAM, CAD, $base64) {

        function updateAccountInfo() {
            this.updateAccountInfo = function (callBackSuccess, oUpdateAccountInfo) {
                var apikey = CAD.getApiKey();
                var params = "&tokenType=SuperUser&tokenID=" + oUpdateAccountInfo.tokenID +
                "&updateAccountInfoType=" + oUpdateAccountInfo.updateAccountInfoType + "&emailAddress=" +
                oUpdateAccountInfo.emailAddress + "&privateGUID=" + oUpdateAccountInfo.privateGUID;
                 var url = CM.getApiUrlWithApikeyAndAppName('UPDATE_ACCOUNT_INFO', "Portal") + params;

                if (url === "URL_ERROR") {

                } else {
                    //var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');
                    var request = {
                        url: url,
                        header: {
                            'Content-Type': 'application/xml',
                            'accept': 'application/xml'
                        },
                        onSuccess: callBackSuccess
                    }

                     cvsUtility.commonServiceCode(url, "updateAccountInfo", UAM, request, callBackSuccess, NS);
                }

            }
        }

        return new updateAccountInfo();
    }]);